const initialState = {
    withdrawData:null
};

export default function (state = initialState, action) {
    switch (action.type) {
        case "SET_WITHDRAW_DATA":
            return {
                ...state,
                withdrawData: action.data,
            };
        default:
            return state;
    }
}
